import { render } from "./CloneDiskOffering.vue?vue&type=template&id=618b36bd&scoped=true"
import script from "./CloneDiskOffering.vue?vue&type=script&lang=js"
export * from "./CloneDiskOffering.vue?vue&type=script&lang=js"

import "./CloneDiskOffering.vue?vue&type=style&index=0&id=618b36bd&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618b36bd"]])

export default __exports__